"use strict";

/// <reference types="jquery"/>
//Récupération de template dans les différents select2 et datatable
$.getSelect2Datas = function () {
    return {
        templateSelection: $.templateSelect2,
        templateResult: $.templateSelect2
    };
};
$.templateSelect2 = function (state) {
    return $("<span>", {
        class: state.element ? $(state.element).attr("class") : state.css,
        text: state.text.replace(/\s\n\r/g, "")
    });
};
$.datatablesTemplates.push({
    name: "transfo-statut",
    callback: function callback(data) {
        return "<span class=\"" + data.StatutCss + "\" data-id=\"" + data.StatutId + "\">\n            " + data.StatutLibelle + "\n            </span>";
    }
});
$.datatablesTemplates.push({
    name: "transfo-tpc",
    callback: function callback(data) {
        return "<div class=\"custom-control custom-checkbox custom-control-inline\" style=\"padding-left: 1rem;\">\n            <input type=\"checkbox\" id=\"Transfo_tpc\" class=\"custom-control-input\"\n            " + (data.Tpc ? "checked" : "") + " disabled>\n            <label class=\"custom-control-label\" for=\"Transfo_tpc\"></label>\n            </div>";
    }
});
$.getSelect2DatasFilter = function () {
    return {
        templateSelection: $.templateSelect2Filter,
        templateResult: $.templateSelect2
    };
};
$.templateSelect2Filter = function (state) {
    var $span = $("<span>", {
        class: state.css,
        text: state.text.replace(/\s\n\r/g, "")
    });
    var $i = $('<i class="fa fa-times cursor-hand ml-3"/>');
    $span.append($i);
    $i.click(function () {
        $(this).parent().prev().click();
    });
    return $span;
};
$.getCallBackTemplate = function (data) {
    return "<span class=\"" + $(data[0].element).attr("class") + "\" data-id=\"" + data[0].value + "\">\n            " + data[0].text + "\n            </span>";
};
//Méthode appelé en cas d'actions rapides
$.transfoActionProcess = function (action, id, callback, onlyOne) {
    if (onlyOne === void 0) {
        onlyOne = true;
    }
    var $transfoContainer = $("div.row-admin-transfo");
    var $modal = $transfoContainer.next();
    var $modalBody = $modal.find(".modal-body");
    var params = $.param({
        id: id,
        adminAction: action,
        onlyOne: onlyOne
    });
    var url = $transfoContainer.data("massive-action-url") + "?" + params;
    //Chargement du contenu de la modale
    $modalBody.load(url, function (result) {
        $(".datetimepicker", $modalBody).each(function () {
            $(this).initDateTimePicker();
        });
        $("select.select2", $modalBody).each(function (i, el) {
            var $el = $(el),
                data = {};
            //Vérification et application si nécessaire du besoin de template custom
            if ($el.data("custom-template")) {
                data = $.getSelect2Datas();
            }
            $(el).select2(data);
        });
        var $footer = $(".modal-footer", $modal);
        $footer.show();
        //En cas de maesage d'erreur seul on cache tous les boutons(si qu'un seul transfo concerné) ou seulement celui de validation
        if ($modalBody.find("> div:first").hasClass("alert")) {
            if (onlyOne) {
                $footer.hide();
            } else {
                $footer.find(".btn-valid").hide();
                $footer.find(".btn-cancel").html("<i class=\"fa fa-ban\"></i> Passer au suivant").off("click").on("click", function () {
                    callback();
                });
            }
            return;
        }
        $(".btn-valid, .btn-cancel", $footer)
        //On set l'affichage des boutons en fonctions de la multiplicité des actions ou pas.
        .each(function (i, btn) {
            var $btn = $(btn);
            $btn.show();
            if ($btn.hasClass("btn-valid")) {
                $btn.html("<i class=\"fa fa-" + (onlyOne ? "check" : "angle-double-right") + "\"></i>\n                                Valider " + (!onlyOne ? "et passer au suivant" : ""));
            } else {
                $btn.html("<i class=\"fa fa-ban\"></i>\n                                Ignorer " + (!onlyOne ? "et passer au suivant" : ""));
            }
        })
        //On configure l'évènement des boutons, en faisant en sorte qu'il ne se lance pas plusieurs fois
        .off("click").on("click", function () {
            var $this = $(this);
            if ($this.hasClass("btn-valid")) {
                var $form = $("#modal-transfo-form", $modal);
                //On vérifie la validité du formaulaire
                if ($form.find(".row-destroy, .datetimepicker").length > 0) {
                    var chkb = $form.find("input:checkbox#AnalyseAFaire");
                    var $alert = $form.find("div.alert");
                    var noValid = chkb.length > 0 ? !chkb.is(":checked") && (!$form.find("input[name=RapportAnalyse]").val() || !$form.find("input[name=EntrepriseAnalyse]").val() || !$form.find("input[name=TxPcb]").val()) : !$form.find("input.datetimepicker").val();
                    if (noValid) {
                        $alert.find("> span:first").text("Merci de remplir tous les champs.");
                        $alert.removeClass("d-none");
                        return false;
                    } else {
                        $alert.hide();
                    }
                }
                //On submit la form en Ajax si tous va bien
                $form.off("form.submit.fail, form.submit.done").on("form.submit.fail, form.submit.done", function () {
                    //Au retour, on stock le transformateur modifié en vue des notifications
                    var actionsDone = $transfoContainer.data("action-for-notification");
                    if (actionsDone && actionsDone.push) {
                        actionsDone.push(id);
                    } else {
                        actionsDone = [id];
                    }
                    $transfoContainer.data("action-for-notification", actionsDone);
                    //Action de retour qui va définir si une autre action doit être lancé ou la modale fermée
                    callback();
                }).submitAjax();
            } else {
                callback();
            }
        });
    });
};
//Méthode appelé par les actions rapides
$.massiveActionProcess = function (action, index) {
    var $transfoContainer = $("div.row-admin-transfo");
    var $datatableDiv = $transfoContainer.find("div.datatable");
    var $modal = $transfoContainer.next();
    var datatable = $datatableDiv.data("datatable");
    var rowsSelected = $transfoContainer.data("rowsSelected") || [];
    //Si il y a plusieurs transformateurs, on lance l'action pour le suivant
    if (index < rowsSelected.length) {
        var id = rowsSelected[index];
        var onlyOne = index === rowsSelected.length - 1;
        $.transfoActionProcess(action, id, function () {
            return $.massiveActionProcess(action, index + 1);
        }, onlyOne);
    }
    //Sinon on traite les infos de retours, les notifications et on ferme la modale
    else {
            $transfoContainer.data("rowsSelected", []);
            $("thead th #check-head").prop("checked", false).trigger("change");
            var actionsDone = $transfoContainer.data("action-for-notification");
            if (actionsDone && actionsDone.length && actionsDone.length > 0) {
                var params = $.param({
                    actionAdmin: action,
                    ids: actionsDone
                }, true);
                $.get($transfoContainer.data("notification-url") + "?" + params);
                $transfoContainer.data("action-for-notification", []);
            }
            $modal.modal("hide");
            datatable.draw();
        }
};
//Méthode appelé par l'enregistrement de l'Edit inline (en cas que cela soit configuré)
$.getActionOnEditInline = function (instance, cell, value) {
    var $container = $("div.row-admin-transfo");
    var $cell = $(cell);
    var actionModal = $container.data("action-modal");
    var datatable = $container.find("div.datatable").data("datatable");
    var datas = datatable.row($cell.parents("tr:first")).data();
    var columName = $(datatable.column(datatable.cell(cell).index().column).header()).data("column");
    var columnValue = datas[columName];
    var valueString = $cell.find("select.select2").length > 0 ? $($cell.find("select.select2").select2("data")[0].element).data("value-string") || "" : "";
    //On vérifie qu'il existe une action correspondante à ce qu'il a été fait, et le cas échéant on lance l'action
    if (columnValue != value && actionModal[columnValue] && actionModal[columnValue][valueString || value]) {
        var action = actionModal[datas[columName]][valueString || value];
        var $modal = $container.next();
        var $modalDiag = $modal.find(".modal-dialog");
        var id = datas["Id"];
        //var actionModalXl = $container.data("modal-action-xl").toString().split(",");
        //$(".modal-title", $modal).text($this.text());
        //if (actionModalXl.indexOf(action.toString()) !== -1) {
        $modalDiag.addClass("modal-xlg");
        //} else {
        //    $modalDiag.removeClass("modal-xlg");
        //}
        $(".modal-title").text($("th[data-column=Action]:first").find(".dropdown-item[data-action-id=" + action + "]").text());
        $.transfoActionProcess(action, id, function () {
            var actionsDone = $container.data("action-for-notification");
            if (actionsDone && actionsDone.length && actionsDone.length > 0) {
                var params = $.param({
                    actionAdmin: action,
                    ids: actionsDone
                }, true);
                $.get($container.data("notification-url") + "?" + params);
                $container.data("action-for-notification", []);
            }
            $modal.modal("hide");
            datatable.draw();
        });
        $modal.modal("show");
    }
    //Sinon on sauvegarde tout bêtement
    else {
            instance.saveValue(cell);
        }
};
//Chargement et ouverture de la colonne de détail d'une ligne de gestion de transformateur
$.fn.loadGestionDetail = function (id, edit) {
    var $target = $(this);
    var params = $.param({
        id: id,
        editMode: edit
    });
    $target.load("/Transformateur/GetDetailGestionTransformateur?" + params, function (data) {
        $target.parents(".row-admin-transfo").addClass("col-detail-open");
        //Si en mode édition, on initialise les controls
        if (edit) {
            $.validator.unobtrusive.parse($target);
            $(".datetimepicker", $target).each(function () {
                $(this).initDateTimePicker();
            });
            $("select.select2", $target).each(function (i, el) {
                var $el = $(el),
                    data = {};
                //Vérification et application si nécessaire du besoin de template custom
                if ($el.data("custom-template")) {
                    data = $.getSelect2Datas();
                }
                $(el).select2(data);
            });
        }
    });
    return $target;
};
$(function () {
    $("body").on("click", ".delete-file", function () {
        var $col = $(this).parents(".file");
        var $fileId = $col.find(".file-id");
        // Si c'est l'input hidden d'une photo, on vire juste la valeur pour savoir qu'elle est supprimée
        if ($fileId.hasClass("photo-id")) {
            $fileId.val(null);
        } else {
            $fileId.prop("disabled", true);
        }
        $col.addClass("d-none");
    });
    var $transfoContainer = $("div.row-admin-transfo");
    //Si on est sur la page, on l'initialise
    if ($transfoContainer.length > 0) {
        var $datatableDiv = $transfoContainer.find("div.datatable"),
            setTimeoutClick,
            searchValues,
            selectRow = function selectRow(selected, data) {
            if (!data || data.length === 0) {
                return;
            }
            var id = data["Id"];
            var rowsSelected = $transfoContainer.data("rowsSelected") || [];
            var index = rowsSelected.indexOf(rowsSelected.filter(function (r) {
                return r === id;
            })[0]);
            if (selected && index === -1) {
                rowsSelected.push(id);
            } else if (!selected && index !== -1) {
                rowsSelected.splice(index, 1);
            }
            $transfoContainer.data("rowsSelected", rowsSelected);
            $datatableDiv.find("thead th div.dropdown #dropdownMenuButton").prop("disabled", rowsSelected.length === 0);
        },
            toggleActionFilter = function toggleActionFilter(toggle) {
            var $btn = $(".btn-toggle-filtre");
            $btn.toggleClass("bg-filter-show", toggle).data("show", toggle);
            $("thead tr:not(:first)", $datatableDiv).toggle(toggle);
            $("tr", $datatableDiv).find("td:first, th:first").toggle(toggle);
        };
        // Pour empêcher le tri lors du clic
        $("div.pop-annee-const").on("click", function (e) {
            e.stopImmediatePropagation();
        });
        //Export excel des données courantes du datatable
        $(".btn-export-transfo").off().on("click", function () {
            $datatableDiv.downloadCsv("/Transformateur/DownloadDatatableCsv");
        });
        //On nettoie à la fermeture de la modal
        $transfoContainer.next().on("hidden.bs.modal", function () {
            var $this = $(this);
            $this.find(".modal-title").text("");
            $this.find(".modal-body").html("<div class=\"text-center\"><i class=\"fa fa-spinner fa-pulse fa-3x fa-fw margin-bottom\"></i></div>");
            $this.find("modal-footer").show();
        });
        $(document)
        //Si touche echappe et filtre année ouvert alors on ferme
        .on("keyup", function (e) {
            if ($("div.pop-annee-const").is(":visible") && e.keyCode === 27) {
                $("div.pop-annee-const").hide();
            }
        })
        //On montre ou on masque filtres et actions
        .on("click", ".btn-toggle-filtre", function () {
            var $this = $(this);
            toggleActionFilter(!$this.data("show"));
            $this.blur();
        })
        //Evenement case à cocher colonne Action
        .on("change", "tbody td input[id^=check-row-]", function () {
            var $this = $(this);
            var $row = $this.parents("tr");
            var datatable = $datatableDiv.data("datatable");
            var row = datatable.row($row);
            var rowData = row.data();
            selectRow($this.is(":checked"), rowData);
        })
        //Evenement action ddl entête première colonne
        .on("click", ".btn-action-head", function () {
            var $this = $(this);
            var idAction = $this.data("action-id");
            var $modal = $transfoContainer.next();
            var $modalDiag = $modal.find(".modal-dialog");
            //var actionModalXl = $transfoContainer.data("modal-action-xl").toString().split(",");
            $(".modal-title", $modal).text($this.text());
            //if (actionModalXl.indexOf(idAction.toString()) !== -1) {
            $modalDiag.addClass("modal-xlg");
            //} else {
            //    $modalDiag.removeClass("modal-xlg");
            //}
            if ($this.parents(".detail-header").length > 0) {
                $("thead th #check-head").prop("checked", false).trigger("change");
                var selectedRows = [$("div.col-details").find("input#Transfo_Id").val()];
                $transfoContainer.data("rowsSelected", selectedRows);
            }
            $.massiveActionProcess(idAction, 0);
            $modal.modal("show");
        })
        //Evenement case à cocher entête première colonne
        .on("change", "thead th #check-head", function () {
            var $this = $(this);
            var $chkb = $("tbody td input[id^=check-row-]");
            $chkb.prop("checked", $this.is(":checked")).trigger("change");
        })
        //On empêche le click sur un select2 de lancer le chargement du detail d'une ligne
        .on("select2:close select2:open select2:select click", ".select2", function (e) {
            e.stopImmediatePropagation();
            e.stopPropagation();
            if (setTimeoutClick) {
                clearTimeout(setTimeoutClick);
                setTimeoutClick = null;
            }
        })
        //Chargement du détail d'une ligne de gestion de transformateur
        .on("click", "div.row-admin-transfo div.datatable table tbody tr", function () {
            var _this = this;
            if (setTimeoutClick) {
                clearTimeout(setTimeoutClick);
                setTimeoutClick = null;
            } else {
                setTimeoutClick = setTimeout(function () {
                    var $this = $(_this),
                        $target = $this.parents("div.col-list").next(),
                        id = $this.data("gt-id");
                    $("tr.detail-show").removeClass("detail-show");
                    $this.addClass("detail-show");
                    $target.loadGestionDetail(id, false);
                    setTimeoutClick = null;
                }, 400);
            }
        })
        //Bouton de création de ligne
        .on("click", ".btn-create-gt", function () {
            var $colDetail = $("div.col-details");
            $colDetail.loadGestionDetail(0, true);
            $(this).blur();
        })
        //On met à jour les valeurs dans le data du datatable pour les colonnes avec un rendu custom
        .on("dt.edited", "div.row-admin-transfo div.datatable table tbody tr td[data-name=Tpc], " + "div.row-admin-transfo div.datatable table tbody tr td[data-name=Statut]", function (e, value) {
            var datatable = $datatableDiv.data("datatable");
            var row = datatable.row($(this).parent());
            var rowData = row.data();
            rowData[$(this).data("name")] = value;
        })
        //Fermeture de la colonne de détail d'une ligne de gestion de transformateur
        .on("click", ".btn-close-detail", function () {
            $(this).parents(".row-admin-transfo").removeClass("col-detail-open");
            $("tr.detail-show").removeClass("detail-show");
        })
        //Passage en mode édition de la colonne détails
        .on("click", ".col-details .detail-header .col-actions .btn-edit", function () {
            var $this = $(this),
                $target = $this.parents(".col-details"),
                id = $this.data("transfo-id");
            $target.loadGestionDetail(id, $this.data("edit") ? true : false);
        })
        //Annulation du mode édition et retour en mode lecture seule de la colonne détails
        .on("click", ".col-details .detail-footer .btn-annule", function () {
            var $this = $(this),
                $target = $this.parents(".col-details"),
                id = $this.parent().data("transfo-id");
            if (id === 0) {
                $(".btn-close-detail").trigger("click");
                return;
            }
            $target.loadGestionDetail(id, false);
        })
        //Enregistrement des modifications apportées dans la colonne détails
        .on("click", ".col-details .detail-footer .btn-submit", function () {
            var $this = $(this),
                $form = $(this.form),
                $alert = $form.find("div.alert"),
                setAlert = function setAlert(message, css) {
                $alert.attr("class", "alert alert-dismissible " + css).find("span:first").text(message);
                $this.removeAttr("disabled").html('<i class="fa fa-save"></i> Enregistrer');
                $(".col-details").animate({
                    scrollTop: 0
                }, 0);
            };
            $this.attr("disabled", "disabled").html('<i class="fa fa-spinner fa-pulse fa-fw"></i>');
            $form.off("form.submit.fail, form.submit.done").on("form.submit.done", function (e, data) {
                if (data["message"]) {
                    setAlert(data["message"], "alert-danger");
                    return;
                }
                var $form = $(this);
                $form.find(".col-title h3").text($form.find("#Transfo_TypeTransfo").val() + " - " + $form.find("#Transfo_Puissance").val() + "kVA");
                $form.find("input#Transfo_Id").val(data["id"]);
                $datatableDiv.data("datatable").draw();
                setAlert("Enregistrement effectué.", "alert-success");
            }).on("form.submit.fail", function (e, data) {
                setAlert(data["message"] || "Une erreur est survenue.", "alert-danger");
            }).submitAjax();
        });
        //Evènements sur le conteneur du datatable
        $datatableDiv.on("add-more-filter", function (e, extraParam) {
            var datatable = $datatableDiv.data("datatable");
            searchValues = extraParam["searchValues"];
            var container = $datatableDiv.find(".pop-annee-const");
            var $de = $("select.annee-de", container);
            var $a = $("select.annee-a", container);
            var $input = $("input.datatable-filter", container.parent());
            var setInput = function setInput(a1, a2) {
                $input.val("" + a1 + (a1 && a2 ? " - " : "") + a2);
            };
            //Filtre sur l'année de fabrication des transformateurs
            var options;
            var $selects = $("select.annee-filter", $datatableDiv.find("table"));
            $selects.on("change", function (e, extraParam) {
                var $filter = $(this);
                var column = datatable.columns($filter.data("column") + ":name");
                // Collage des valeurs sélectionnées avec une virgule
                var value = $filter.val();
                column.search(value);
                $datatableDiv.trigger("filter-change", { source: "column-filter.change" });
                if ($filter.hasClass("annee-de")) {
                    var filterVal = $filter.val();
                    var filteredOptions = filterVal ? options.filter(function (o) {
                        return !o.id || o.id >= $filter.val();
                    }) : options;
                    var $selectA = $selects.filter(function (i, s) {
                        return $(s).hasClass("annee-a");
                    });
                    var valA = $selectA.val();
                    $selectA.html("");
                    filteredOptions.map(function (o) {
                        if (!o.id) {
                            o.text = "";
                        }
                        $selectA.append($("<option>", {
                            value: o.id,
                            text: o.text
                        }));
                    });
                    if (valA) {
                        $selectA.val(valA);
                    }
                }
            });
            $.get($($selects[0]).data("ajax--url"), function (data) {
                options = data.results;
                var $options = options.map(function (o) {
                    if (!o.id) {
                        o.text = "";
                    }
                    $selects.append($("<option>", {
                        value: o.id,
                        text: o.text
                    }));
                });
            });
            //Bouton d evalidation du filtre sur l'année de fabrication d'un transformateur
            $(".btn-filter-annee", $datatableDiv.find("table")).on("click", function (e) {
                e.stopImmediatePropagation();
                var deVal = $de.val() || "";
                var aVal = $a.val() || "";
                if (!deVal && !aVal) {
                    var columnDe = datatable.columns($de.data("column") + ":name");
                    var columnA = datatable.columns($a.data("column") + ":name");
                    columnDe.search("");
                    columnA.search("");
                } else {
                    setInput(deVal, aVal);
                    container.toggle();
                    $datatableDiv.trigger("filter-change", { source: "column-filter.change" });
                }
                $(this).parents("th").toggleClass("filtered", deVal !== "" || aVal !== "");
                datatable.draw();
            });
            if (searchValues && searchValues.length > 0) {
                var colNameDe = $de.data("column");
                var colNameA = $a.data("column");
                var valueDe = searchValues[colNameDe] || "";
                var valueA = searchValues[colNameA] || "";
                setInput(valueDe, valueA);
                $de.parents("th").toggleClass("filtered", valueA !== "" || valueDe !== "");
            }
        }).on("filter-change", function (e, extraParam) {
            if (extraParam && extraParam.source && extraParam.source === "column-filter.unfilter") {
                var datatable = $datatableDiv.data("datatable");
                var container = $datatableDiv.find(".pop-annee-const");
                var $de = $("select.annee-de", container);
                var $a = $("select.annee-a", container);
                var $input = $("input.datatable-filter", container.parent());
                var columnDe = datatable.columns($de.data("column") + ":name");
                var columnA = datatable.columns($a.data("column") + ":name");
                columnDe.search("");
                $de.html("");
                columnA.search("");
                $a.html("");
                $input.val("");
                $input.parents("th").removeClass("filtered");
            }
        }).on("createdRow", function (e, row, data) {
            var $row = $(row);
            var id = data["Id"];
            $row.attr("data-gt-id", id);
            //Ajout de la case à cocher dans la colonne "Action"
            $("td:first", $row).append("<div class=\"custom-control custom-checkbox custom-control-inline m-0\" style=\"padding-left: 1rem;\">\n                                <input type=\"checkbox\" id=\"check-row-" + id + "\" class=\"custom-control-input\">\n                                <label class=\"custom-control-label\" for=\"check-row-" + id + "\"></label>\n                            </div>");
        }).on("draw", function () {
            if ($transfoContainer.hasClass("col-detail-open")) {
                var $colDetail = $("div.col-details");
                var idDetail = $colDetail.find("input#Transfo_Id").val();
                if (!idDetail || idDetail == 0 || idDetail === "") {
                    $transfoContainer.removeClass("col-detail-open");
                } else {
                    $("tbody tr[data-gt-id=" + idDetail + "]").addClass("detail-show");
                    $colDetail.loadGestionDetail(idDetail, false);
                }
            }
            var $btnShowFilter = $(".btn-toggle-filtre");
            if (!$btnShowFilter.data("show")) {
                toggleActionFilter(false);
            }
        }).setDatatable();
        $datatableDiv.find("thead tr").removeAttr("style");
    }
});


//////////////////
// WEBPACK FOOTER
// ./_wwwsrc/js/Transformateur/index.ts
// module id = 613
// module chunks = 0